import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[typeof Symbol === "function" ? Symbol.iterator : "@@iterator"] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      return function () {
        if (i >= o.length) return {
          done: true
        };
        return {
          done: false,
          value: o[i++]
        };
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  it = o[typeof Symbol === "function" ? Symbol.iterator : "@@iterator"]();
  return it.next.bind(it);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _clsx from "clsx";
import _babelRuntimeHelpersEsmExtends from "@babel/runtime/helpers/esm/extends";
import _react, { useContext, useEffect, useRef, useState } from "react";
import { getInteractionModality, useFocus, useFocusVisible, useFocusWithin, useKeyboard } from "@react-aria/interactions";
import { focusWithoutScrolling, runAfterTransition, useLayoutEffect, mergeProps } from "@react-aria/utils";
export function focusSafely(element) {
  if (getInteractionModality() === 'virtual') {
    var lastFocusedElement = document.activeElement;
    runAfterTransition(function () {
      if (document.activeElement === lastFocusedElement && document.contains(element)) {
        focusWithoutScrolling(element);
      }
    });
  } else {
    focusWithoutScrolling(element);
  }
}

var $c9e8f80f5bb1841844f54e4ad30b$var$FocusContext = _react.createContext(null);

var $c9e8f80f5bb1841844f54e4ad30b$var$activeScope = null;
var $c9e8f80f5bb1841844f54e4ad30b$var$scopes = new Set();
export function FocusScope(props) {
  var children = props.children,
      contain = props.contain,
      restoreFocus = props.restoreFocus,
      autoFocus = props.autoFocus;
  var startRef = useRef();
  var endRef = useRef();
  var scopeRef = useRef([]);
  useLayoutEffect(function () {
    var node = startRef.current.nextSibling;
    var nodes = [];

    while (node && node !== endRef.current) {
      nodes.push(node);
      node = node.nextSibling;
    }

    scopeRef.current = nodes;
    $c9e8f80f5bb1841844f54e4ad30b$var$scopes.add(scopeRef);
    return function () {
      $c9e8f80f5bb1841844f54e4ad30b$var$scopes.delete(scopeRef);
    };
  }, [children]);
  $c9e8f80f5bb1841844f54e4ad30b$var$useFocusContainment(scopeRef, contain);
  $c9e8f80f5bb1841844f54e4ad30b$var$useRestoreFocus(scopeRef, restoreFocus, contain);
  $c9e8f80f5bb1841844f54e4ad30b$var$useAutoFocus(scopeRef, autoFocus);
  var focusManager = $c9e8f80f5bb1841844f54e4ad30b$var$createFocusManager(scopeRef);
  return _react.createElement($c9e8f80f5bb1841844f54e4ad30b$var$FocusContext.Provider, {
    value: focusManager
  }, _react.createElement("span", {
    hidden: true,
    ref: startRef
  }), children, _react.createElement("span", {
    hidden: true,
    ref: endRef
  }));
}
export function useFocusManager() {
  return useContext($c9e8f80f5bb1841844f54e4ad30b$var$FocusContext);
}

function $c9e8f80f5bb1841844f54e4ad30b$var$createFocusManager(scopeRef) {
  return {
    focusNext: function focusNext(opts) {
      if (opts === void 0) {
        opts = {};
      }

      var node = opts.from || document.activeElement;
      var focusable = $c9e8f80f5bb1841844f54e4ad30b$var$getFocusableElementsInScope(scopeRef.current, opts);
      var nextNode = focusable.find(function (n) {
        return !!(node.compareDocumentPosition(n) & (Node.DOCUMENT_POSITION_FOLLOWING | Node.DOCUMENT_POSITION_CONTAINED_BY));
      });

      if (!nextNode && opts.wrap) {
        nextNode = focusable[0];
      }

      if (nextNode) {
        nextNode.focus();
      }

      return nextNode;
    },
    focusPrevious: function focusPrevious(opts) {
      if (opts === void 0) {
        opts = {};
      }

      var node = opts.from || document.activeElement;
      var focusable = $c9e8f80f5bb1841844f54e4ad30b$var$getFocusableElementsInScope(scopeRef.current, opts).reverse();
      var previousNode = focusable.find(function (n) {
        return !!(node.compareDocumentPosition(n) & (Node.DOCUMENT_POSITION_PRECEDING | Node.DOCUMENT_POSITION_CONTAINED_BY));
      });

      if (!previousNode && opts.wrap) {
        previousNode = focusable[0];
      }

      if (previousNode) {
        previousNode.focus();
      }

      return previousNode;
    }
  };
}

var $c9e8f80f5bb1841844f54e4ad30b$var$focusableElements = ['input:not([disabled]):not([type=hidden])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', 'a[href]', 'area[href]', 'summary', 'iframe', 'object', 'embed', 'audio[controls]', 'video[controls]', '[contenteditable]'];
var $c9e8f80f5bb1841844f54e4ad30b$var$FOCUSABLE_ELEMENT_SELECTOR = $c9e8f80f5bb1841844f54e4ad30b$var$focusableElements.join(',') + ',[tabindex]';
$c9e8f80f5bb1841844f54e4ad30b$var$focusableElements.push('[tabindex]:not([tabindex="-1"])');
var $c9e8f80f5bb1841844f54e4ad30b$var$TABBABLE_ELEMENT_SELECTOR = $c9e8f80f5bb1841844f54e4ad30b$var$focusableElements.join(':not([tabindex="-1"]),');

function $c9e8f80f5bb1841844f54e4ad30b$var$getFocusableElementsInScope(scope, opts) {
  var res = [];
  var selector = opts.tabbable ? $c9e8f80f5bb1841844f54e4ad30b$var$TABBABLE_ELEMENT_SELECTOR : $c9e8f80f5bb1841844f54e4ad30b$var$FOCUSABLE_ELEMENT_SELECTOR;

  for (var _iterator = _createForOfIteratorHelperLoose(scope), _step; !(_step = _iterator()).done;) {
    var node = _step.value;

    if (node.matches(selector)) {
      res.push(node);
    }

    res.push.apply(res, _toConsumableArray(Array.from(node.querySelectorAll(selector))));
  }

  return res;
}

function $c9e8f80f5bb1841844f54e4ad30b$var$useFocusContainment(scopeRef, contain) {
  var focusedNode = useRef();
  var raf = useRef(null);
  useEffect(function () {
    var scope = scopeRef.current;

    if (!contain) {
      return;
    }

    var onKeyDown = function onKeyDown(e) {
      if (e.key !== 'Tab' || e.altKey || e.ctrlKey || e.metaKey) {
        return;
      }

      var focusedElement = document.activeElement;

      if (!$c9e8f80f5bb1841844f54e4ad30b$var$isElementInScope(focusedElement, scope)) {
        return;
      }

      var elements = $c9e8f80f5bb1841844f54e4ad30b$var$getFocusableElementsInScope(scope, {
        tabbable: true
      });
      var position = elements.indexOf(focusedElement);
      var lastPosition = elements.length - 1;
      var nextElement = null;

      if (e.shiftKey) {
        if (position <= 0) {
          nextElement = elements[lastPosition];
        } else {
          nextElement = elements[position - 1];
        }
      } else {
        if (position === lastPosition) {
          nextElement = elements[0];
        } else {
          nextElement = elements[position + 1];
        }
      }

      e.preventDefault();

      if (nextElement) {
        $c9e8f80f5bb1841844f54e4ad30b$var$focusElement(nextElement, true);
      }
    };

    var onFocus = function onFocus(e) {
      var isInAnyScope = $c9e8f80f5bb1841844f54e4ad30b$var$isElementInAnyScope(e.target, $c9e8f80f5bb1841844f54e4ad30b$var$scopes);

      if (!isInAnyScope) {
        if (focusedNode.current) {
          focusedNode.current.focus();
        } else if ($c9e8f80f5bb1841844f54e4ad30b$var$activeScope) {
          $c9e8f80f5bb1841844f54e4ad30b$var$focusFirstInScope($c9e8f80f5bb1841844f54e4ad30b$var$activeScope.current);
        }
      } else {
        $c9e8f80f5bb1841844f54e4ad30b$var$activeScope = scopeRef;
        focusedNode.current = e.target;
      }
    };

    var onBlur = function onBlur(e) {
      raf.current = requestAnimationFrame(function () {
        var isInAnyScope = $c9e8f80f5bb1841844f54e4ad30b$var$isElementInAnyScope(document.activeElement, $c9e8f80f5bb1841844f54e4ad30b$var$scopes);

        if (!isInAnyScope) {
          $c9e8f80f5bb1841844f54e4ad30b$var$activeScope = scopeRef;
          focusedNode.current = e.target;
          focusedNode.current.focus();
        }
      });
    };

    document.addEventListener('keydown', onKeyDown, false);
    document.addEventListener('focusin', onFocus, false);
    scope.forEach(function (element) {
      return element.addEventListener('focusin', onFocus, false);
    });
    scope.forEach(function (element) {
      return element.addEventListener('focusout', onBlur, false);
    });
    return function () {
      document.removeEventListener('keydown', onKeyDown, false);
      document.removeEventListener('focusin', onFocus, false);
      scope.forEach(function (element) {
        return element.removeEventListener('focusin', onFocus, false);
      });
      scope.forEach(function (element) {
        return element.removeEventListener('focusout', onBlur, false);
      });
    };
  }, [scopeRef, contain]);
  useEffect(function () {
    return function () {
      return cancelAnimationFrame(raf.current);
    };
  }, [raf]);
}

function $c9e8f80f5bb1841844f54e4ad30b$var$isElementInAnyScope(element, scopes) {
  for (var _iterator2 = _createForOfIteratorHelperLoose(scopes.values()), _step2; !(_step2 = _iterator2()).done;) {
    var scope = _step2.value;

    if ($c9e8f80f5bb1841844f54e4ad30b$var$isElementInScope(element, scope.current)) {
      return true;
    }
  }

  return false;
}

function $c9e8f80f5bb1841844f54e4ad30b$var$isElementInScope(element, scope) {
  return scope.some(function (node) {
    return node.contains(element);
  });
}

function $c9e8f80f5bb1841844f54e4ad30b$var$focusElement(element, scroll) {
  if (scroll === void 0) {
    scroll = false;
  }

  if (element != null && !scroll) {
    try {
      focusSafely(element);
    } catch (err) {}
  } else if (element != null) {
    try {
      element.focus();
    } catch (err) {}
  }
}

function $c9e8f80f5bb1841844f54e4ad30b$var$focusFirstInScope(scope) {
  var elements = $c9e8f80f5bb1841844f54e4ad30b$var$getFocusableElementsInScope(scope, {
    tabbable: true
  });
  $c9e8f80f5bb1841844f54e4ad30b$var$focusElement(elements[0]);
}

function $c9e8f80f5bb1841844f54e4ad30b$var$useAutoFocus(scopeRef, autoFocus) {
  useEffect(function () {
    if (autoFocus) {
      $c9e8f80f5bb1841844f54e4ad30b$var$activeScope = scopeRef;

      if (!$c9e8f80f5bb1841844f54e4ad30b$var$isElementInScope(document.activeElement, $c9e8f80f5bb1841844f54e4ad30b$var$activeScope.current)) {
        $c9e8f80f5bb1841844f54e4ad30b$var$focusFirstInScope(scopeRef.current);
      }
    }
  }, [scopeRef, autoFocus]);
}

function $c9e8f80f5bb1841844f54e4ad30b$var$useRestoreFocus(scopeRef, restoreFocus, contain) {
  useLayoutEffect(function () {
    var scope = scopeRef.current;
    var nodeToRestore = document.activeElement;

    var onKeyDown = function onKeyDown(e) {
      if (e.key !== 'Tab' || e.altKey || e.ctrlKey || e.metaKey) {
        return;
      }

      var focusedElement = document.activeElement;

      if (!$c9e8f80f5bb1841844f54e4ad30b$var$isElementInScope(focusedElement, scope)) {
        return;
      }

      var walker = getFocusableTreeWalker(document.body, {
        tabbable: true
      });
      walker.currentNode = focusedElement;
      var nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();

      if ((!nextElement || !$c9e8f80f5bb1841844f54e4ad30b$var$isElementInScope(nextElement, scope)) && nodeToRestore) {
        walker.currentNode = nodeToRestore;

        do {
          nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
        } while ($c9e8f80f5bb1841844f54e4ad30b$var$isElementInScope(nextElement, scope));

        e.preventDefault();
        e.stopPropagation();

        if (nextElement) {
          nextElement.focus();
        } else {
          focusedElement.blur();
        }
      }
    };

    if (!contain) {
      document.addEventListener('keydown', onKeyDown, true);
    }

    return function () {
      if (!contain) {
        document.removeEventListener('keydown', onKeyDown, true);
      }

      if (restoreFocus && nodeToRestore && $c9e8f80f5bb1841844f54e4ad30b$var$isElementInScope(document.activeElement, scope)) {
        requestAnimationFrame(function () {
          if (document.body.contains(nodeToRestore)) {
            $c9e8f80f5bb1841844f54e4ad30b$var$focusElement(nodeToRestore);
          }
        });
      }
    };
  }, [scopeRef, restoreFocus, contain]);
}

export function getFocusableTreeWalker(root, opts) {
  var selector = (opts == null ? void 0 : opts.tabbable) ? $c9e8f80f5bb1841844f54e4ad30b$var$TABBABLE_ELEMENT_SELECTOR : $c9e8f80f5bb1841844f54e4ad30b$var$FOCUSABLE_ELEMENT_SELECTOR;
  var walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
    acceptNode: function acceptNode(node) {
      var _opts$from;

      if (opts == null ? void 0 : (_opts$from = opts.from) == null ? void 0 : _opts$from.contains(node)) {
        return NodeFilter.FILTER_REJECT;
      }

      if (node.matches(selector)) {
        return NodeFilter.FILTER_ACCEPT;
      }

      return NodeFilter.FILTER_SKIP;
    }
  }, false);

  if (opts == null ? void 0 : opts.from) {
    walker.currentNode = opts.from;
  }

  return walker;
}
export function useFocusRing(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      within = _props.within;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFocused = _useState2[0],
      setFocused = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isFocusWithin = _useState4[0],
      setFocusWithin = _useState4[1];

  var _useFocusVisible = useFocusVisible(props),
      isFocusVisible = _useFocusVisible.isFocusVisible;

  var _useFocus = useFocus({
    isDisabled: within,
    onFocusChange: setFocused
  }),
      focusProps = _useFocus.focusProps;

  var _useFocusWithin = useFocusWithin({
    isDisabled: !within,
    onFocusWithinChange: setFocusWithin
  }),
      focusWithinProps = _useFocusWithin.focusWithinProps;

  return {
    isFocused: within ? isFocusWithin : isFocused,
    isFocusVisible: (within ? isFocusWithin : isFocused) && isFocusVisible,
    focusProps: within ? focusWithinProps : focusProps
  };
}
export function FocusRing(props) {
  var _clsx2;

  var children = props.children,
      focusClass = props.focusClass,
      focusRingClass = props.focusRingClass;

  var _useFocusRing = useFocusRing(props),
      isFocused = _useFocusRing.isFocused,
      isFocusVisible = _useFocusRing.isFocusVisible,
      focusProps = _useFocusRing.focusProps;

  var child = _react.Children.only(children);

  return _react.cloneElement(child, mergeProps(child.props, _babelRuntimeHelpersEsmExtends({}, focusProps, {
    className: _clsx((_clsx2 = {}, _defineProperty(_clsx2, focusClass || '', isFocused), _defineProperty(_clsx2, focusRingClass || '', isFocusVisible), _clsx2))
  })));
}

var $e11539c8317b2d21639df611cb5658f$var$FocusableContext = _react.createContext(null);

function $e11539c8317b2d21639df611cb5658f$var$useFocusableContext(ref) {
  var context = useContext($e11539c8317b2d21639df611cb5658f$var$FocusableContext) || {};
  useEffect(function () {
    if (context && context.ref) {
      context.ref.current = ref.current;
      return function () {
        context.ref.current = null;
      };
    }
  }, [context, ref]);
  return context;
}

function $e11539c8317b2d21639df611cb5658f$var$FocusableProvider(props, ref) {
  var children = props.children,
      otherProps = _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose(props, ["children"]);

  var context = _babelRuntimeHelpersEsmExtends({}, otherProps, {
    ref: ref
  });

  return _react.createElement($e11539c8317b2d21639df611cb5658f$var$FocusableContext.Provider, {
    value: context
  }, children);
}

export var FocusableProvider = _react.forwardRef($e11539c8317b2d21639df611cb5658f$var$FocusableProvider);
export function useFocusable(props, domRef) {
  var _useFocus2 = useFocus(props),
      focusProps = _useFocus2.focusProps;

  var _useKeyboard = useKeyboard(props),
      keyboardProps = _useKeyboard.keyboardProps;

  var interactions = mergeProps(focusProps, keyboardProps);
  var domProps = $e11539c8317b2d21639df611cb5658f$var$useFocusableContext(domRef);
  var interactionProps = props.isDisabled ? {} : domProps;
  useEffect(function () {
    if (props.autoFocus && domRef.current) {
      domRef.current.focus();
    }
  }, [props.autoFocus, domRef]);
  return {
    focusableProps: mergeProps(_babelRuntimeHelpersEsmExtends({}, interactions, {
      tabIndex: props.excludeFromTabOrder && !props.isDisabled ? -1 : undefined
    }), interactionProps)
  };
}